// extracted by mini-css-extract-plugin
export default {"input":"CustomVariants_input__ppKaN"};